import getMailPath from 'owa-url/lib/getMailPath';

export const getCurrentRoute = (): string[] => {
    let route = [];

    // The below code ensures that the route changes due to react-router is preserved
    const mailBasePath = getMailPath();

    // Check for mail base in the URL to make sure we are intercepting the routes once
    // the mail module is bootstrapped.
    if (window.location.pathname.indexOf(mailBasePath) > -1) {
        route = window.location.pathname
            .replace(mailBasePath, '')
            .split('/')
            .map(decodeURIComponent)
            .filter(r => r);
    }

    return route;
};
